/*
 * (c) Copyright 2024 Calabrio, Inc.
 * All Rights Reserved. www.calabrio.com LICENSED MATERIALS
 * Property of Calabrio, Inc., Minnesota, USA
 *
 * No part of this publication may be reproduced, stored or transmitted,
 * in any form or by any means (electronic, mechanical, photocopying,
 * recording or otherwise) without prior written permission from Calabrio, Inc.
 */

// import _ from 'lodash';
import PerformanceService from '../../service/performance';
import WyPanelUtils from '../../components/panel-views/utils/wy-panel-util.js';
import WyFilter from '../../library/wy-filter.js';
import _ from 'lodash';

const state = {
}

const getters = {
}

const mutations = {
}

const actions = {
  async fetchIntentToContainConversationChartData({getters}, payloadOptions) {
    let payload = WyFilter.filterValues(getters.shareState, getters.dataModel, WyFilter.MODE_DATE_A);
    payload.selection = payloadOptions.selection;
    
    let res = await PerformanceService.fetchIntentToContainConversationChartData(getters.authUser, payload);
    let viewByData = null
    if(res && res.data && res.status == 200) {
      viewByData = res.data;
    }
    return viewByData;
  },

  async fetchIntentToHandedOffConversationChartData({getters}, selection) {
    let payload = WyFilter.filterValues(getters.shareState, getters.dataModel, WyFilter.MODE_DATE_A);
    payload.selection = selection
    let res = await PerformanceService.fetchIntentToHandedOffConversationChartData(getters.authUser, payload);
    let viewByData = null
    if(res && res.data && res.status == 200) {
      viewByData = res.data;
    }
    return viewByData;
  },
  
  async fetchIntentToConversationByLanguagesChartData({getters}, selection) {
    let payload = WyFilter.filterValues(getters.shareState, getters.dataModel, WyFilter.MODE_DATE_A);
    payload.selection = selection
    let res = await PerformanceService.fetchIntentToConversationByLanguagesChartData(getters.authUser, payload);
    let viewByData = null
    if(res && res.data && res.status == 200) {
      viewByData = res.data;
    }
    return viewByData;
  },

  async fetchIntentToConversationByChannelsChartData({getters}, selection) {
    let payload = WyFilter.filterValues(getters.shareState, getters.dataModel, WyFilter.MODE_DATE_A);
    payload.selection = selection
    let res = await PerformanceService.fetchIntentToConversationByChannelsChartData(getters.authUser, payload);
    let viewByData = null
    if(res && res.data && res.status == 200) {
      viewByData = res.data;

      // do label mapping
      if(viewByData.conversationsByChannels && viewByData.conversationsByChannels.fieldList && Array.isArray(viewByData.conversationsByChannels.fieldList)) {
        const custTypesMap = getters.authUser.config.app.configs.channelsMapping || {};
        viewByData.conversationsByChannels.fieldList.map(item => {
          if(custTypesMap[item.key] && custTypesMap[item.key] != '') {
            item.label = custTypesMap[item.key];
          }          
        })
      }
    }
    return viewByData;
  },

  async fetchIntentToMessageUnderstandingChartData({getters}, {selection, messageLength}) {
    let payload = WyFilter.filterValues(getters.shareState, getters.dataModel, WyFilter.MODE_DATE_A);
    payload.selection = selection;
    payload.messageLength = messageLength;
    let res = await PerformanceService.fetchIntentToMessageUnderstandingChartData(getters.authUser, payload);
    let viewByData = null
    if(res && res.data && res.status == 200) {
      viewByData = res.data;
    }
    return viewByData;
  },

  // eslint-disable-next-line no-unused-vars
  async preparePerformanceViewByData({getters, commit},{viewBy, rawData, templateData, companyConfig}) {
    if(rawData && Object.keys(rawData).length > 0) {
      let viewByData = JSON.parse(JSON.stringify(rawData));
      let viewByDailyData = JSON.parse(JSON.stringify(rawData));
      let panelName = Object.keys(viewByData)[0]
      // console.log(companyConfig)
      let legendOriginColors = [];
      if(companyConfig && companyConfig.legends && companyConfig.legends.legendColors && companyConfig.legends.legendColors.length > 0) {
        legendOriginColors = _.uniq(_.concat(companyConfig.legends.legendColors, getters.legendDefaultColors));
        // legendOriginColors = companyConfig.legends.legendColors;
      }
      else {
        legendOriginColors = getters.legendDefaultColors
      }
      // console.log(getters.companyConfig, getters.legendOriginColors)
      commit('updateLegendOriginColors', {colors: legendOriginColors});
      commit('updateLegendColors', {colors: legendOriginColors});
      if(viewBy && panelName) {
        switch (panelName) {
          case 'containedConversations':
            viewByData[panelName].conversationsPieChartLegendKeys = ['handoff', 'contained'];
            viewByData[panelName].containedPieChartLegendKeys = ['resolved', 'abandoned'];
            viewByData.containedConversations.containmentRateLineChartData = WyPanelUtils.arverageGroupBy(viewBy, viewByData.containedConversations.containmentRateLineChartData, ['containmentRate'])
            viewByData.containedConversations.conversationsBarChartData = WyPanelUtils.totalVolumGroupBy(viewBy, viewByData.containedConversations.conversationsBarChartData, viewByData[panelName].conversationsPieChartLegendKeys)
            viewByData.containedConversations.containedBarChartData = WyPanelUtils.totalVolumGroupBy(viewBy, viewByData.containedConversations.containedBarChartData, viewByData[panelName].containedPieChartLegendKeys)
            viewByData.containedConversations.costSavingsLineChartData = WyPanelUtils.totalVolumGroupBy(viewBy, viewByData.containedConversations.costSavingsLineChartData, ['costSavings'])
            return WyPanelUtils.formatPanelChartData(viewByData, viewByDailyData, panelName, templateData, viewBy, legendOriginColors);
          
          case 'handedOffConversations':
            viewByData[panelName].conversationsPieChartLegendKeys = ['handoff', 'contained'];
            viewByData[panelName].handedOffPieChartLegendKeys = ['customerRequested', 'programmed'];

            // console.log(viewByData[panelName], viewByData[panelName].conversationsPieChartData)
            viewByData[panelName].conversationsBarChartData = WyPanelUtils.totalVolumGroupBy(viewBy, viewByData[panelName].conversationsBarChartData, viewByData[panelName].conversationsPieChartLegendKeys)
            viewByData[panelName].handedOffBarChartData = WyPanelUtils.totalVolumGroupBy(viewBy, viewByData[panelName].handedOffBarChartData, viewByData[panelName].handedOffPieChartLegendKeys)
            viewByData[panelName].handoffRateLineChartData = WyPanelUtils.arverageGroupBy(viewBy, viewByData[panelName].handoffRateLineChartData, ['handoffRate'])
            
            return WyPanelUtils.formatPanelChartData(viewByData, viewByDailyData, panelName, templateData, viewBy, legendOriginColors);

          case 'messageUnderstanding':
            viewByData[panelName].customerMessagesPieChartLegendKeys = ['messagesUnderstood', 'messagesNotUnderstood'];
            viewByData[panelName].messagesUnderstoodPieChartLegendKeys = ['correctClassification', 'falsePositive'];
            viewByData[panelName].messagesNotUnderstoodPieChartLegendKeys = ['shortMessages', 'longMessages'];

            viewByData[panelName].nluLineChartData = WyPanelUtils.arverageGroupBy(viewBy, viewByData[panelName].nluLineChartData, ['nlu'])
            viewByData[panelName].customerMessagesBarChartData = WyPanelUtils.totalVolumGroupBy(viewBy, viewByData[panelName].customerMessagesBarChartData, viewByData[panelName].customerMessagesPieChartLegendKeys)
            viewByData[panelName].messagesUnderstoodBarChartData = WyPanelUtils.totalVolumGroupBy(viewBy, viewByData[panelName].messagesUnderstoodBarChartData, viewByData[panelName].messagesUnderstoodPieChartLegendKeys)
            viewByData[panelName].messagesNotUnderstoodBarChartData = WyPanelUtils.totalVolumGroupBy(viewBy, viewByData[panelName].messagesNotUnderstoodBarChartData, viewByData[panelName].messagesNotUnderstoodPieChartLegendKeys)
            return WyPanelUtils.formatPanelChartData(viewByData, viewByDailyData, panelName, templateData, viewBy, legendOriginColors);

          case 'conversationsByLanguages': {
            let languageList = [];
            const languageTotalList = [];
            viewByData[panelName].fieldList.forEach(field => {
              languageList.push(field.prefix);
              languageTotalList.push('total'+field.suffix);
              WyPanelUtils.updateLegendMap(field);
            })
            let languageOriginList = [];
            let languageFullList = getters.languageOriginList;
            if(companyConfig && companyConfig.languages && companyConfig.languages.length > 0) {
              languageOriginList = WyPanelUtils.mergeList(companyConfig.languages, languageFullList);
            }
            else {
              languageOriginList = languageFullList;
            }
            languageList = WyPanelUtils.updateFieldList(languageOriginList, languageList)
            viewByData[panelName].fieldList = WyPanelUtils.updateFieldObjectList(viewByData[panelName].fieldList, languageList);
            let legendColors = commit('updateLegendColors', {colors: WyPanelUtils.getLegendColor(languageOriginList, legendOriginColors, languageList)});
            commit('updateLegendColors', {colors: WyPanelUtils.getLegendColor(languageOriginList, legendOriginColors, languageList)});
            // console.log(legendOriginColors, languageOriginList, getters.legendColors, languageList, languageFullList)
            templateData = WyPanelUtils.dynamicCreateTemplateData(templateData, languageList, viewByData[panelName].fieldList);
            viewByData[panelName].conversationsPieChartLegendKeys = languageList;
            viewByData[panelName].conversationsBarChartData = WyPanelUtils.totalVolumGroupBy(viewBy, viewByData[panelName].conversationsBarChartData, viewByData[panelName].conversationsPieChartLegendKeys)
            languageList.forEach(lan => {
              viewByData[panelName][lan + 'PieChartLegendKeys'] = ['handoff', 'contained'];
              viewByData[panelName][lan + 'BarChartData'] = WyPanelUtils.totalVolumGroupBy(viewBy, viewByData[panelName][lan + 'BarChartData'], viewByData[panelName][lan + 'PieChartLegendKeys'])
            })
            // viewByData[panelName].handedOffBarChartData = totalVolumGroupBy(viewBy, viewByData[panelName].handedOffBarChartData, ['customerRequested', 'programmed'])
            // viewByData[panelName].handoffRateLineChartData = arverageGroupBy(viewBy, viewByData[panelName].handoffRateLineChartData, ['handoffRate'])
            return WyPanelUtils.formatPanelChartData(viewByData, viewByDailyData, panelName, templateData, viewBy, legendOriginColors, legendColors);
          }
          case 'conversationsByChannels': {
            let channelList = [];
            const channelTotalList = [];
            viewByData[panelName].fieldList.forEach(field => {
              channelList.push(field.prefix);
              channelTotalList.push('total'+field.suffix);
              WyPanelUtils.updateLegendMap(field);
            })

            let channelOriginList = [];
            let channelFullList = getters.channelOriginList;
            if(companyConfig && companyConfig.channels && companyConfig.channels.length > 0) {
              channelOriginList = WyPanelUtils.mergeList(companyConfig.channels, channelFullList);
            }
            else {
              channelOriginList = channelFullList;
            }
            channelList = WyPanelUtils.updateFieldList(channelOriginList, channelList);
            viewByData[panelName].fieldList = WyPanelUtils.updateFieldObjectList(viewByData[panelName].fieldList, channelList);
            let legendColors = WyPanelUtils.getLegendColor(channelOriginList, legendOriginColors, channelList)
            commit('updateLegendColors', {colors: WyPanelUtils.getLegendColor(channelOriginList, legendOriginColors, channelList)});
            // console.log(legendOriginColors, channelOriginList, getters.legendColors, channelList, channelFullList)
            templateData = WyPanelUtils.dynamicCreateTemplateData(templateData, channelList, viewByData[panelName].fieldList);
            
            viewByData[panelName].conversationsPieChartLegendKeys = channelList;

            viewByData[panelName].conversationsBarChartData = WyPanelUtils.totalVolumGroupBy(viewBy, viewByData[panelName].conversationsBarChartData, viewByData[panelName].conversationsPieChartLegendKeys)
            channelList.forEach(channel => {
              viewByData[panelName][channel + 'PieChartLegendKeys'] = ['handoff', 'contained'];
              viewByData[panelName][channel + 'BarChartData'] = WyPanelUtils.totalVolumGroupBy(viewBy, viewByData[panelName][channel + 'BarChartData'], viewByData[panelName][channel + 'PieChartLegendKeys'])
            })
            // console.log(viewByData)
            return WyPanelUtils.formatPanelChartData(viewByData, viewByDailyData, panelName, templateData, viewBy, legendOriginColors, legendColors);
          }
          default:
        }
      }
      else {
        return {}
      }
    }
    else {
      return templateData;
    }
  },

  async fetchIntentToIntents({getters}, selection) {
    let payload = WyFilter.filterValues(getters.shareState, getters.dataModel, WyFilter.MODE_DATE_A);
    payload.selection = selection
    
    let res = await PerformanceService.fetchIntentToIntents(getters.authUser, payload);
    if(res && res.data) {
      return res.data;
    }
    return null;
  },
}

export default {
  state,
  getters,
  mutations,
  actions
}